import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ImportSafTComponent } from './import-saf-t.component';
import { DirectivesModule } from '../directives/directives.module';
import { SafTFilesSelectorImporterComponent } from './saf-t-files-selector-importer/saf-t-files-selector-importer.component';

@NgModule({
  declarations: [ImportSafTComponent, SafTFilesSelectorImporterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  exports: [ImportSafTComponent]
})
export class ImportSafTModule {
  customElementComponent: Type<any> = ImportSafTComponent;
}
